export const GET_PASSWORD_RESET_TOKEN_PENDING =
  'GET_PASSWORD_RESET_TOKEN_PENDING'
export const GET_PASSWORD_RESET_TOKEN_SUCCESSFUL =
  'GET_PASSWORD_RESET_TOKEN_SUCCESSFUL'
export const GET_PASSWORD_RESET_TOKEN_ERROR = 'GET_PASSWORD_RESET_TOKEN_ERROR'

export const RESET_PASSWORD_PENDING = 'RESET_PASSWORD_PENDING'
export const RESET_PASSWORD_SUCCESSFUL = 'RESET_PASSWORD_SUCCESSFUL'
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR'
